import { DialogTitle } from '@savvy-kit/components/dialog';
import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import TrackedDialog from 'src/components/tracked/tracked-dialog';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

type Props = {
  readonly deleteButton: React.ReactElement;
  readonly descriptionRow: React.ReactElement;
  readonly detailRows: React.ReactElement;
  readonly editButton: React.ReactElement;
  readonly headerText?: string;
  readonly secondaryDetailRows?: React.ReactElement;
  readonly onClose: () => void;
};

export function ViewPortfolioItemDialog({
  deleteButton,
  descriptionRow,
  detailRows,
  editButton,
  headerText,
  secondaryDetailRows,
  onClose,
}: Props) {
  const isSmallScreen = useIsSmallScreen();
  return (
    <TrackedDialog
      elementName="view-portfolio-item-dialog"
      open
      onOpenChange={(nextOpen) => !nextOpen && onClose()}
      size={isSmallScreen ? 'fullscreen' : undefined}
      className={cn('flex flex-col p-6', !isSmallScreen && 'max-h-[85vh]')}
    >
      <DialogTitle className="sr-only">Portfolio item details</DialogTitle>
      <div className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto">
        {descriptionRow}
        <Text variant="subtitle-lg" color="dark">
          {headerText}
        </Text>
        <div className="flex flex-col gap-0">{detailRows}</div>
        {secondaryDetailRows}
        <div className={cn('flex flex-row gap-6', isSmallScreen ? 'justify-center' : 'justify-end')}>
          {deleteButton}
          {editButton}
        </div>
      </div>
    </TrackedDialog>
  );
}
